enum LoadsSearchParamName {
  // Time range
  Day = 'day',
  Year = 'year',
  Month = 'month',
  Hour = 'hour',
  Minute = 'minute',
  NumDays = 'days',
  // Options
  Field = 'sort_field',
  Order = 'sort_order',
  IncludeMissingPriceLoads = 'include_missing_price',
  // Filters
  TrailerTypes = 'trailer_type',
  EquipmentLength = 'trailer_length',
  RatePerMile = 'rpm',
  Price = 'price',
  Weight = 'weight',
  Distance = 'distance',
  // Requirements
  RequirementsOnly = 'only',
  RequirementsNever = 'never',
  // Pickup
  PickupZone = 'pickup_zone',
  PickupState = 'pickup_state',
  PickupBase64EncodedLocation = 'pickup',
  PickupRadiusMiles = 'pickup_radius',
  // Delivery
  DeliveryZone = 'delivery_zone',
  DeliveryState = 'delivery_state',
  DeliveryBase64EncodedLocation = 'delivery',
  DeliveryRadiusMiles = 'delivery_radius',
  // Brokers
  BrokerList = 'broker',
  ShouldExcludeBrokerList = 'exclude',
  // Entry points
  SelectLoadEntryPoint = 'select_load_entry_point',
  // Exclude load id
  ExcludeLoadId = 'exclude_load_id',
}

export default LoadsSearchParamName;
